const PRIMARY_USER_ID_KEY = 'emporion_customer_user_id'
export const AUTH_CHANGE_EVENT = 'emporion:customer-auth-changed'
const AUTH_SYNC_SIGNAL_KEY = 'emporion_customer_auth_signal'

let runtimeToken: string | null = null

export const readStoredToken = () => {
  return runtimeToken
}

export const persistIdentity = (token: string, userId: string) => {
  runtimeToken = token.trim() || null
  if (typeof window === 'undefined') return
  window.localStorage.setItem(PRIMARY_USER_ID_KEY, userId)
}

export const clearPersistedIdentity = () => {
  runtimeToken = null
  if (typeof window === 'undefined') return
  window.localStorage.removeItem(PRIMARY_USER_ID_KEY)
}

export const setRuntimeToken = (token: string | null) => {
  runtimeToken = token?.trim() || null
}

export const dispatchAuthChanged = () => {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(AUTH_SYNC_SIGNAL_KEY, String(Date.now()))
  } catch {
    // best-effort cross-tab signal
  }
  window.dispatchEvent(new Event(AUTH_CHANGE_EVENT))
}

export const isAuthStorageKey = (key: string | null) =>
  !key || key === PRIMARY_USER_ID_KEY || key === AUTH_SYNC_SIGNAL_KEY

export const hasPersistedIdentity = () => {
  if (typeof window === 'undefined') return false
  const userId = window.localStorage.getItem(PRIMARY_USER_ID_KEY)
  return typeof userId === 'string' && userId.trim().length > 0
}
